import { styled } from "@mui/material/styles";

import InputBase, {
  InputBaseProps,
} from "@mui/material/InputBase";

import { ReactNode } from "react";

import React from "react";

interface CustomInputProps
  extends InputBaseProps {
  endAdornment?: ReactNode;
}

const CustomInputWrapper = styled(
  InputBase
)(({ theme }) => ({
  width: "100%",

  position: "relative",

  // ================= INPUT =================

  "& .MuiInputBase-input": {
    position: "relative",

    width: "100%",

    color: "#ffffff",

    fontSize: 12,

    fontWeight: 400,

    letterSpacing: "0.4px",

    padding: "10px 5px",

    borderRadius: "8px",

    // ================= GLASS EFFECT =================

    background:
      "rgba(255,255,255,0.06)",

    backdropFilter: "blur(18px)",

    WebkitBackdropFilter: "blur(18px)",

    border:
      "1px solid rgba(255,255,255,0.10)",

    transition:
      "all 0.35s ease-in-out",

    boxShadow:
      "0px 8px 30px rgba(0,0,0,0.15)",

    // ================= PLACEHOLDER =================

    "&::placeholder": {
      color: "rgba(255,255,255,0.65)",

      opacity: 1,
    },

    // ================= HOVER =================

    "&:hover": {
      border:
        "1px solid rgba(48,119,157,0.45)",

      background:
        "rgba(255,255,255,0.08)",
    },

    // ================= FOCUS =================

    "&:focus": {
      border:
        "1px solid #30779d",

      background:
        "rgba(255,255,255,0.10)",

      boxShadow:
        "0px 10px 35px rgba(48,119,157,0.28)",
    },
  },

  // ================= END ADORNMENT =================

  "& .MuiInputAdornment-positionEnd": {
    position: "absolute",

    right: "18px",

    top: "50%",

    transform: "translateY(-50%)",

    color: "rgba(255,255,255,0.7)",

    fontSize: "12px",
  },
}));

export default function CustomInput(
  props: CustomInputProps
) {
  const { endAdornment, ...other } =
    props;

  return (
    <CustomInputWrapper
      {...other}
      endAdornment={endAdornment}
    />
  );
}